module.exports = __webpack_public_path__ + "img/icon60.a197070a.png";